import * as S from "./ModalJoinRestriction.style";
import { Buttons } from "@/components/atoms/Buttons";
import { ModalProps, Modals } from "..";

interface ModalConfirmProps extends ModalProps {}

export const ModalJoinRestriction = ({ setModalShow }: ModalConfirmProps) => {
  const handleConfirm = () => {
    setModalShow(false);
  };

  return (
    <Modals
      setModalShow={setModalShow}
      modalButtons={
        <>
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="확인"
            onClick={handleConfirm}
          />
        </>
      }
    >
      <S.ModalJoinRestriction>
        <S.ModalHeader>알림</S.ModalHeader>
        <S.ModalContent>
          <span>
            선착순 인원 모집이 마감되어 신규 회원가입이 중단되었습니다.
          </span>
        </S.ModalContent>
        <S.ModalFooter>
          <span>담당자 문의</span>
          <span className="divider" />
          <span>051-253-3533</span>
        </S.ModalFooter>
      </S.ModalJoinRestriction>
    </Modals>
  );
};
